import { createBlueprint as e } from "@made-people/blueprint";
const t = e({
  slots: {
    wrapper: "block relative overflow-hidden bg-neutral-400 [&_*]:text-text-body",
    ticker: "h-full",
    item: "mx-1 px-1.5 my-2 flex h-5 flex justify-center items-center",
    label: "text-body-sm"
  },
  variants: {
    color: {
      mint: { wrapper: "" }
      // stronger
    }
  }
}), i = {
  main: t
}, r = e({
  slots: {
    wrapper: "relative overflow-hidden",
    fade: "h-full h-7 relative w-full flex justify-center items-center ",
    item: "h-full block absolute transform -translate-x-1/2",
    label: "text-body-sm"
  },
  variants: {
    theme: {
      primary: {
        wrapper: "bg-primary text-black"
      },
      secondary: {
        wrapper: "bg-secondary text-white"
      },
      tertiary: {
        wrapper: "bg-tertiary text-white"
      },
      black: {
        wrapper: "bg-black text-white"
      },
      white: {
        wrapper: "bg-white text-black"
      }
    },
    color: {
      purple: {
        wrapper: ""
      }
    }
  },
  defaultVariants: {
    color: "purple"
  }
}), o = {
  main: r
}, l = e({
  slots: {
    wrapper: "relative overflow-hidden",
    static: "h-full flex flex-row items-center",
    item: "flex h-7 flex-1 justify-center items-center",
    label: "text-body-sm"
  },
  variants: {
    color: {
      mint: {
        wrapper: ""
      }
    }
  }
}), n = {
  main: l
};
export {
  o as fadeStyling,
  n as staticStyling,
  i as tickerStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
